var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-card__buttons" },
    [
      _vm.quantity > 0
        ? _c("div", { staticClass: "qty" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.addToCartQuantity,
                  expression: "addToCartQuantity"
                }
              ],
              staticClass: "product-quantity",
              attrs: {
                type: "number",
                name: "quantity",
                min: "1",
                max: _vm.quantity
              },
              domProps: { value: _vm.addToCartQuantity },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.addToCartQuantity = $event.target.value
                }
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-overlay",
        {
          staticClass: "d-inline-block",
          attrs: {
            show: _vm.showAddToCartBtnLoadingOverlay,
            rounded: "",
            opacity: "0.6",
            "spinner-small": "",
            "spinner-variant": "primary"
          }
        },
        [
          _c(
            "b-button",
            {
              ref: "button",
              staticClass:
                "btn btn-primary btn-btn-conversion product-card__addtocart",
              attrs: {
                disabled: _vm.showAddToCartBtnLoadingOverlay,
                variant: "primary"
              },
              on: {
                click: function($event) {
                  return _vm.handleAddToCart()
                }
              }
            },
            [
              !_vm.hideIcon
                ? _c("span", { staticClass: "mh-icon" }, [
                    _c(
                      "svg",
                      {
                        staticClass: "bi bi-cart3",
                        attrs: {
                          width: "2em",
                          height: "1.4em",
                          viewBox: "0 0 16 16",
                          fill: "currentColor",
                          xmlns: "http://www.w3.org/2000/svg"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            d:
                              "M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .49.598l-1 5a.5.5 0 0 1-.465.401l-9.397.472L4.415 11H13a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM3.102 4l.84 4.479 9.144-.459L13.89 4H3.102zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm7 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
                          }
                        })
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("span", { staticClass: "btn-text" }, [
                _vm._v("\n              " + _vm._s(_vm.text) + "\n            ")
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }